import Alert from '@mui/material/Alert'

export default function ErrorMessage({ message }: { message: string }) {
  return <Alert severity="error" sx={{ my: 1 }}>{message}</Alert>
}
